import { Injectable, inject } from '@angular/core';
import { EMPTY, Observable, expand, map, scan } from 'rxjs';

import { GraphService } from 'src/app/shared/lib/api/graph.service';

import { GET_EXPENSE_RECONCILIATION_PAGE } from '../graphql/expense-reconciliation.queries';
import {
  ExpenseReconciliationPage,
  ExpenseReconciliationPageInput,
  ExpenseReconciliationPageResponse,
  ExpenseReconciliationProgress,
} from '../models/expense-reconciliation.models';

@Injectable({ providedIn: 'root' })
export class ExpenseReconciliationService {
  private readonly graphQL = inject(GraphService);

  getPage(
    input: ExpenseReconciliationPageInput = {},
  ): Observable<ExpenseReconciliationPage> {
    return this.graphQL
      .queryGraphQL<ExpenseReconciliationPageResponse>({
        query: GET_EXPENSE_RECONCILIATION_PAGE,
        variables: {
          input: {
            ...input,
            limit: input.limit ?? 50,
          },
        },
      })
      .pipe(map(response => response.getConciliacionEgresosPage));
  }

  getProgressively(
    input: ExpenseReconciliationPageInput = {},
  ): Observable<ExpenseReconciliationProgress> {
    const firstPageInput = { ...input, nextToken: undefined };
    const initialProgress: ExpenseReconciliationProgress = {
      items: [],
      loadedPages: 0,
      hasMore: true,
    };

    return this.getPage(firstPageInput).pipe(
      expand(page =>
        page.hasMore && page.nextToken
          ? this.getPage({ ...input, nextToken: page.nextToken })
          : EMPTY,
      ),
      scan(
        (progress, page) => ({
          items: [...progress.items, ...page.items],
          loadedPages: progress.loadedPages + 1,
          hasMore: page.hasMore,
        }),
        initialProgress,
      ),
    );
  }
}
